<template>
    <div class="cdiv">
        <div class="header flex">
            <div>
                <el-image class="weiziiconst" :src="require('../assets/img/dingwei.png')" fit="cover"></el-image>
            </div>
            <div class="pleft">
                当前位置：<span>首页</span><span>>火车票预订</span><span>>预订</span>
            </div>
        </div>
        <div class="addpgstyle flex">添加乘客方式 <div style="margin-left: auto;"><button @click="addStandby">新增备用车次</button></div></div>
        <div class="tcontentxc flex">
            <div class="commonmtop">
                <div class="sccdate flex">
                    <div class="startzhan">{{ fromStation }}</div>
                    <div class="iconstyles">
                        <el-image style="margin-left: 1vw" class="weiziicon" :src="require('../assets/img/shi.png')"
                            fit="cover"></el-image>
                    </div>
                </div>
                <div class="scdiv flex startweight bluecolor">
                    {{ fromTime }}
                </div>
            </div>
            <div class="haoshi commonmtops">
                <div class="cxinfo"><span style="margin-right: 30px;">{{rq}}</span> {{ trainCode }}</div>
                <div class="mtopsinfo">
                    <el-image class="weiziicon" :src="require('../assets/img/xian.png')" fit="cover"></el-image>
                </div>
                <div class="sleft smargintop">
                    {{ formateHour(runTime) }}小时{{ runTime.slice(3, 5) }}分
                </div>
            </div>
            <div class="endcheci commonmtop">
                <div class="sccdate flex">
                    <div class="startzhan">{{ toStation }}</div>
                    <div class="iconstyles">
                        <el-image style="margin-left: 1vw" class="weiziicon" :src="require('../assets/img/zhong.png')"
                            fit="cover"></el-image>
                    </div>
                </div>
                <div class="scdiv flex startweight bluecolor">
                    {{ toTime }}
                </div>
            </div>
        </div>
        <div class="tcontentxc flex" v-for="(item, index) in standbyList" :key="index">
            <div style="position: absolute;left: 20px;top: 10px;color: red;font-weight: bold;">备</div>
            <div style="position: absolute;right: 20px;top: 10px;font-weight: bold;cursor: pointer;" @click="handleDeleteStandby(item, index)">删除</div>
            <div class="commonmtop">
                <div class="sccdate flex">
                    <div class="startzhan">{{ item.fromStation }}</div>
                    <div class="iconstyles">
                        <el-image style="margin-left: 1vw" class="weiziicon" :src="require('../assets/img/shi.png')"
                            fit="cover"></el-image>
                    </div>
                </div>
                <div class="scdiv flex startweight bluecolor">
                    {{ item.fromTime }}
                </div>
            </div>
            <div class="haoshi commonmtops">
                <div class="cxinfo"><span style="margin-right: 30px;">{{item.date}}</span> {{ item.trainCode }}</div>
                <div class="mtopsinfo">
                    <el-image class="weiziicon" :src="require('../assets/img/xian.png')" fit="cover"></el-image>
                </div>
                <div class="sleft smargintop">
                    {{ formateHour(item.runTime) }}小时{{ item.runTime.slice(3, 5) }}分
                </div>
            </div>
            <div class="endcheci commonmtop">
                <div class="sccdate flex">
                    <div class="startzhan">{{ item.toStation }}</div>
                    <div class="iconstyles">
                        <el-image style="margin-left: 1vw" class="weiziicon" :src="require('../assets/img/zhong.png')"
                            fit="cover"></el-image>
                    </div>
                </div>
                <div class="scdiv flex startweight bluecolor">
                    {{ item.toTime }}
                </div>
            </div>
        </div>
        <Commuter ref="commuterRef"
            :trainCode="trainCode"
            :send_time="`${rq} ${fromTime}`"
            :from="fromStation"
            :to="toStation"
            :passengersList="passengersList"/>
        <div class="remark">备注</div>
        <div class="remarkinfo">
            <el-input type="textarea" v-model="remarkTkorder" maxlength="500" show-word-limit resize="none" :rows="5"
                class="textarea-box" placeholder="请输入备注信息"></el-input>
        </div>
        <div class="addpg">
            <el-button class="orderbtn" :disabled="logLoading" @click="submitorder">提交订单</el-button>
        </div>
        <div class="shuoming">
            <div>说明</div>
            <div class="remark">
                {{remark}}
            </div>
        </div>
        <div class="copyright">工业和信息化部备案管理系统网站 豫B1-20080191-28</div>
    </div>
</template>

<script>
import ElImage from "element-ui/packages/image/src/main";
import ElButton from "element-ui/packages/button/src/button";
import Commuter from "./Commuter.vue";
import { addOrderInfo, yundingRemark } from "@/api";
import Cookie from 'js-cookie';
export default {
    components: {
        ElButton,
        ElImage,
        Commuter,
    },
    data() {
        return {
            standbyList: [],
            remark: '',
            pgname: "",
            pgshow: false,
            dialogbgsryVisible: false,
            dialogcypgVisible: false,
            dialoggatxzVisible: false,
            dialogsfzVisible: false,
            logLoading: false,
            dialogVisible: false,
            textareaValue: "",
            fromStation: "",
            trainCode: "",
            fromTime: "",
            runTime: "",
            toStation: "",
            toTime: "",
            rq: "",
            orderMoney: "",
            remarkTkorder: "",
            pginfo: "",
            form: {
                date1: "",
                sendcity: "",
                arrivalcity: "",
                cardimg: "",
            },
            passengersList:[],
            rules: {
                mobilephone: [
                    { required: true, message: "请输入手机号", trigger: "blur" },
                    { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" },
                ],

                pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
            },
            fileList: [],
            companyList: [],
            defaultUserList: [],
            seat: [],
            seats: []
        };
    },
    activated() {
        const userinfo =JSON.parse(Cookie.get('userinfo'));
        this.userinfo = userinfo;
        const queryData = this.$route.query;
        
        const userId = this.userinfo.id;
        const trainMasterOrderKey = `${userId}-train-master-order`;
        const trainStandbyOrderKey = `${userId}-train-standby-order`;
        const trainMasterSeatsKey = `${userId}-train-master-seats`;
        const trainUserListKey = `${userId}-train-user-list`;
        const trainMasterOrder = localStorage.getItem(trainMasterOrderKey)
        const trainStandbyOrder = localStorage.getItem(trainStandbyOrderKey)
        const trainMasterSeats = localStorage.getItem(trainMasterSeatsKey)
        const trainUserList = localStorage.getItem(trainUserListKey)
        let masterData = queryData;
        this.standbyList = [];
        if(trainStandbyOrder != null) {
            this.standbyList = JSON.parse(trainStandbyOrder);
        }
        if(trainMasterOrder != null) {
            masterData = JSON.parse(trainMasterOrder);
            if(masterData.date != queryData.date || masterData.trainCode != queryData.trainCode) {
                const same = this.standbyList.find(s => s.date == queryData.date && s.trainCode == queryData.trainCode);
                if(!same) {
                    this.standbyList.push(queryData);
                    localStorage.setItem(trainStandbyOrderKey, JSON.stringify(this.standbyList));
                }
            }
        }
        if(trainUserList != null) {
            this.passengersList = JSON.parse(trainUserList);
        }
        
        this.trainCode = masterData.trainCode;
        this.fromStation = masterData.fromStation;
        this.fromTime = masterData.fromTime;
        this.runTime = masterData.runTime;
        this.toStation = masterData.toStation;
        this.toTime = masterData.toTime;
        this.rq = masterData.date
        this.orderMoney = masterData.orderMoney;
        this.seat = masterData.seat ? masterData.seat.split("-") : [];

        this.textareaValue = ""
        this.seats = trainMasterSeats ? JSON.parse(trainMasterSeats): ((this.$route.params && this.$route.params.seats) ? this.$route.params.seats: []);
        //console.log(this.seats, this.$route.params)
        this.remarkTkorder = '';
        yundingRemark().then(res => {
            if(res.data.code == 1) {
                this.remark = res.data.data.draw_demand;
            }
        })
        
        this.$refs.commuterRef.team_number = '';
    },
    methods: {
        handleDeleteStandby(item, index) {
            const userId = this.userinfo.id;
            const trainStandbyOrderKey = `${userId}-train-standby-order`;
            let trainStandbyOrder = localStorage.getItem(trainStandbyOrderKey);
            if(trainStandbyOrder) {
                trainStandbyOrder = JSON.parse(trainStandbyOrder);
                trainStandbyOrder = trainStandbyOrder.filter(t => t.trainCode != item.trainCode);
                localStorage.setItem(trainStandbyOrderKey, JSON.stringify(trainStandbyOrder));
            }
            this.standbyList.splice(index, 1);
        },
        addStandby() {
            const queryData = this.$route.query;
            const userId = this.userinfo.id;
            const trainMasterOrderKey = `${userId}-train-master-order`;
            const trainStandbyOrderKey = `${userId}-train-standby-order`;
            const trainMasterSeatsKey = `${userId}-train-master-seats`;
            const trainUserListKey = `${userId}-train-user-list`;
            const trainMasterOrder = localStorage.getItem(trainMasterOrderKey)
            const trainStandbyOrder = localStorage.getItem(trainStandbyOrderKey)
            if(trainMasterOrder == null) {
                localStorage.setItem(trainMasterOrderKey, JSON.stringify(queryData));
                localStorage.setItem(trainMasterSeatsKey, JSON.stringify(this.seats));
            }
            else {
                const trainMasterData = JSON.parse(trainMasterOrder);
                if(trainMasterData.date != queryData.date || trainMasterData.trainCode != queryData.trainCode) {
                    let standbyArr = []
                    if(trainStandbyOrder != null) {
                        standbyArr = JSON.parse(trainStandbyOrder)
                    }
                    const same = standbyArr.find(s => s.date == queryData.date && s.trainCode == queryData.trainCode);
                    if(!same) {
                        standbyArr.push(queryData);
                        localStorage.setItem(trainStandbyOrderKey, JSON.stringify(standbyArr));
                    }
                }
            }
            const passengersList = this.$refs.commuterRef.ruleForm.passengersList;
            localStorage.setItem(trainUserListKey, JSON.stringify(passengersList));
            this.$router.push(`/trainyuding?from=${queryData.fromStation}&to=${queryData.toStation}&date=${queryData.date}`);
        },
        formateHour(runTime) {
            if (runTime && runTime[0] === '0') {
                return runTime.substr(1, 1)
            }
            return runTime.substr(0, 2)
        },
        validateSfz(value) {
            if (!value || value.length !== 18) {
                // this.$message.error('请输入正确的身份证号');
                return false
            }
            return true
        },
        async submitorder() {
            const individual_traveler = this.$refs.commuterRef.individual_traveler;
            const team_number = this.$refs.commuterRef.team_number;
            if(individual_traveler == '0') {
                if(!team_number) {
                    this.$message.error('请输入团号');
                    return;
                }
            }
            const validFlag = this.$refs.commuterRef.checkForm();
            if(!validFlag) return;
            if (this.logLoading) return
            this.logLoading = true;
            const passengersList = this.$refs.commuterRef.ruleForm.passengersList;
            const user = Cookie.get('phoneKey');
            const  danweinamestr=Cookie.get('danweinameKey');
            
            const trainStandbyOrderKey = `${this.userinfo.id}-train-standby-order`;
            const trainStandbyOrder = localStorage.getItem(trainStandbyOrderKey);
            let journey = [];
            if(trainStandbyOrder != null) {
                const trainStandbyData = JSON.parse(trainStandbyOrder);
                journey = trainStandbyData.map(t => ({
                    departure_station: t.fromStation,
                    arrival_station: t.toStation,
                    train_number: t.trainCode,
                    send_date: t.date+ ' ' + t.fromTime,
                    order_money: t.orderMoney,
                    runtime: t.runTime,
                    arrival_date: t.date + ' ' + t.toTime,
                    xiwei: t.seatTypeName
                }));
            }
            const params = {
                individual_traveler,
                team_number,
                user_id:this.userinfo.id,
                danwei_name:this.userinfo.gs_name,
                departure_station: this.fromStation,
                arrival_station: this.toStation,
                train_number: this.trainCode,
                send_date: this.rq + ' ' + this.fromTime,
                arrival_date: this.rq + ' ' + this.toTime,
                runtime: this.runTime,
                order_money: this.orderMoney,
                remark_tkorder: this.remarkTkorder,
                pg_name:[],
                seats: this.seats,
                journey
            }

            try {
                // 判断重复的身份证
                const idList = {}
                passengersList.forEach((item,index) => {
                    const rytypestr = item.rytype;
                    const xingmingstr = item.user;
                    if ("" == rytypestr || null == rytypestr) {
                        throw new Error("乘客信息"+(index+1)+"请选择人员类型");
                    }
                    if ("" == xingmingstr || null == xingmingstr) {
                        throw new Error("乘客信息"+(index+1)+"请输入姓名");
                    }
                    if (!item.idtype) {
                        throw new Error("乘客信息"+(index+1)+"请选择证件类型");
                    }
                    if (!item.id || (!this.validateSfz(item.id) && item.idtype === '1')) {
                        throw new Error("乘客信息"+(index+1)+"请输入正确证件号");
                    }
                    if (!item.zuoxi) {
                        throw new Error("乘客信息"+(index+1)+"请输入席座");
                    }
                    if (idList[item.id + '_' + item.idtype]) {
                        throw new Error(`乘客信息`+(index+1)+`证件号${item.id}重复`);
                    }
                    idList[item.id + '_' + item.idtype] = true
                    
                    params.pg_name.push({
                        xinming:xingmingstr,
                        card_id:item.id,
                        renyuan_leixing:rytypestr,
                        card_type:item.idtype,
                        xiwei:item.zuoxi,
                        sleeper_seat: item.sleeper_seat,
                        is_buy_baoxian:item.isbaoxian ? '1' : '2',
                        nationality: item.nationality,
                        birthday: item.birthday,
                        effective_date: item.effective_date,
                        sex: item.sex
                    })
                })
            } catch (error) {
                this.$message.error(error.message);
                return;
            }
            finally {
                this.logLoading = false
            }

            const data = await addOrderInfo(params);
            if (data && data.data && data.data.code == 1) {
                this.$refs.commuterRef.team_number = '';
                const userId = this.userinfo.id;
                const trainMasterOrderKey = `${userId}-train-master-order`;
                const trainStandbyOrderKey = `${userId}-train-standby-order`;
                const trainMasterSeatsKey = `${userId}-train-master-seats`;
                localStorage.removeItem(trainMasterOrderKey);
                localStorage.removeItem(trainStandbyOrderKey);
                localStorage.removeItem(trainMasterSeatsKey);
                this.$message.success(data.data.message)
                this.$router.push({
                    path: '/trainorder'
                })
            }
            else {
                this.$message.error(data.data.message)
            }
        },
    },
    name: "trainyudingshenqing-right",
};
</script>

<style scoped>
.smargintop {
    margin-top: 15px;
}

.mtopsinfo {
    margin-top: 10px;
    height: 1px;
}



.remarkinfo {
}

.weiziiconst {
    width: 24px;
    height: 24px;
}


.cdiv {
    /*margin-top:30px;*/
}

.shuoming {
    font-size: 13px;
    color: #444444;
    line-height: 25px;
}

.textarea-box {
    width: calc(100% - 0px - 0px) !important;
    background-color: #f1f1f1;
    margin-top: 2vh;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
}

.textarea-box /deep/ .el-textarea__inner {
    background-color: #f1f1f1;
}

.remark {
    font-weight: bolder;
}

.orderbtn {
    width: 350px;
    height: 45px;
    border: 1px solid #42b134;
    color: #ffffff;
    padding: 10px;
    margin-top: 5vh;
    background-color: #42b134;
}




.btnoper {}

.bluecolor {
    color: #42b134;
}

.startweight {
    font-weight: bolder;
    font-size: 20px;
}

.iconstyles {}

.addpgstyle {
    font-weight: bolder;
    margin-top: 2vh;
}

.copyright {
    width: calc(88% - 0px - 10px) !important;
    font-size: 12px;
    text-align: center;
    margin-top: 5vh;
    color: #b6b6b6;
}

.mleftmargin {
    margin-left: 1vw;
}

.pager {
    margin-top: 5vh;
    margin-left: 10vw;
}

.shouye {}

.sybtn {
    width: 100px;
    height: 35px;
    border: 1px solid #666666;
    text-align: center;
}

.btnnodiv {
    margin-left: 1vw;
}

.btnno {
    width: 50px;
    height: 35px;
    border: 1px solid #666666;
    text-align: center;
}

.commonmtops {
    margin-top: 15px;
}

.commonmtop {
    margin-top: 20px;
}

.btnmargin {
    margin-top: 1vh;
}

.btnstyle {
    width: 100px;
    height: 35px;
    background-color: #42b134;
    color: #ffffff;
    border-radius: 5px;
}

.operbtn {
    margin-left: 8vw;
}

.checizuowei {
    margin-left: 5vw;
}

.colorstyle {
    color: #f49200;
    font-weight: bolder;
}

.checileixing {
    margin-left: 5vw;
}

.checimoney {
    margin-left: 5vw;
}

.zwleixing {
    margin-top: 0.1vh;
}

.cmtopzw {
    margin-top: 2vh;
}

.cxinfo {}

.endcheci {
    margin-left: 3vw;
}

.sleft {}

.scheci {
    margin-left: 2vw;
}

.startzhan {
    margin-left: 0.5vw;
}

.scdiv {
    margin-top: 10px;
    margin-left: 1vw;
}

.sccdate {
    font-size: 20px;
    font-weight: bolder;
}

.haoshi {
    margin-left: 3vw;
    width: 462px;
    justify-content: center;
    justify-items: center;
    text-align: center;
}

.tcontentxc {
    background-color: #f1f1f1;
    height: 100px;
    margin-top: 2vh;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    justify-content: center;
    display: flex;
    position: relative;
}

.tcontent {
    background-color: #f1f1f1;
    height: 20vh;
    margin-top: 2vh;
    width: calc(88% - 0px - 10px) !important;
    padding-top: 4vh;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
}

.mleftd {
    margin-left: -2vw;
}

.addpg {
    text-align: center;
}

.querybtn {
    background-color: #42b134;
    color: #ffffff;
    border-radius: 5px;
    margin-left: -1vw;
}

.formstyleyd {
    padding-top: 2.2vh;
}

.container {}

.header {
    font-size: 12px;
}

.flex {
    display: flex;
}

.weiziicon {}

.pleft {
    margin-left: 0.5vw;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
}
</style>
